import styled from 'styled-components';

import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { space4XL, spaceXL } from '@xing-com/tokens';

export const Wrapper = styled.div`
  padding: ${spaceXL} 0;
  display: flex;
  flex-direction: column;
  gap: ${space4XL};
  @media ${mediaSmallOrTiny} {
    padding: 0;
  }
`;
